import React from 'react';

import { Container } from './styles';

export default function PageLayout({ loading = false, children }) {
  return <Container>{loading ? null : <>{children}</>}</Container>;
}
